import { z } from 'zod';

const ModuleSchema = z.object({
  enabled: z.boolean(),
});

const SpaModuleSchema = z.object({
  enabled: z.boolean(),
  features: z
    .object({
      classes: ModuleSchema.optional(),
      days: ModuleSchema.optional(),
      facilities: ModuleSchema.optional(),
      packages: ModuleSchema.optional(),
      treatments: ModuleSchema.optional(),
    })
    .optional(),
});

// @TODO complete schema when more data is required
export const PropertySchema = z.object({
  id: z.number(),
  modules_excluding_disabled: z.object({
    products: ModuleSchema.optional(),
    rooms: ModuleSchema.optional(),
    tables: ModuleSchema.optional(),
    spa: SpaModuleSchema.optional(),
    vouchers: ModuleSchema.optional(),
    events: ModuleSchema.optional(),
  }),
  uuid: z.string(),
});

export const ModuleStatusSchema = z.object({
  _type: z.literal('ModuleStatuses'),
  roomsEnabled: z.boolean(),
});
